var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaswitchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#metaswitch_icon_svg__clip0_3979_2686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15.273A7.273 7.273 0 108 .728a7.273 7.273 0 000 14.545z",
    fill: "url(#metaswitch_icon_svg__paint0_radial_3979_2686)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "metaswitch_icon_svg__paint0_radial_3979_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-3.21 110.862 -114.543) scale(9.518)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E5B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F7DDA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F5D27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#EDB860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DD8927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D67029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D0612B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#C7462D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "metaswitch_icon_svg__clip0_3979_2686"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM5NzlfMjY4NikiPgo8cGF0aCBkPSJNOC4wMDAwMiAxNS4yNzNDMTIuMDE2NiAxNS4yNzMgMTUuMjcyNyAxMi4wMTY5IDE1LjI3MjcgOC4wMDAyN0MxNS4yNzI3IDMuOTgzNjUgMTIuMDE2NiAwLjcyNzUzOSA4LjAwMDAyIDAuNzI3NTM5QzMuOTgzNDEgMC43Mjc1MzkgMC43MjcyOTUgMy45ODM2NSAwLjcyNzI5NSA4LjAwMDI3QzAuNzI3Mjk1IDEyLjAxNjkgMy45ODM0MSAxNS4yNzMgOC4wMDAwMiAxNS4yNzNaIiBmaWxsPSJ1cmwoI3BhaW50MF9yYWRpYWxfMzk3OV8yNjg2KSIvPgo8L2c+CjxkZWZzPgo8cmFkaWFsR3JhZGllbnQgaWQ9InBhaW50MF9yYWRpYWxfMzk3OV8yNjg2IiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDYuNTg3ODkgNi4wMjgwOCkgcm90YXRlKC0zLjIxKSBzY2FsZSg5LjUxOCkiPgo8c3RvcCBzdG9wLWNvbG9yPSIjRjlFNUI5Ii8+CjxzdG9wIG9mZnNldD0iMC4wOCIgc3RvcC1jb2xvcj0iI0Y3RERBMCIvPgo8c3RvcCBvZmZzZXQ9IjAuMTIiIHN0b3AtY29sb3I9IiNGNUQyN0YiLz4KPHN0b3Agb2Zmc2V0PSIwLjIxIiBzdG9wLWNvbG9yPSIjRURCODYwIi8+CjxzdG9wIG9mZnNldD0iMC40NiIgc3RvcC1jb2xvcj0iI0REODkyNyIvPgo8c3RvcCBvZmZzZXQ9IjAuNjEiIHN0b3AtY29sb3I9IiNENjcwMjkiLz4KPHN0b3Agb2Zmc2V0PSIwLjgyIiBzdG9wLWNvbG9yPSIjRDA2MTJCIi8+CjxzdG9wIG9mZnNldD0iMC45NSIgc3RvcC1jb2xvcj0iI0M3NDYyRCIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzM5NzlfMjY4NiI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgMetaswitchIcon as ReactComponent };